import { ApiResponse } from '@models/common/api';
import { ICreateOrganizationRequest, IOrganizationAnalyticsRequest } from '@models/organization/request';
import {
  ICreateOrganizationResponse,
  IFindOneOrganizationResponse,
  IFindOrganizationResponse,
  IOrganizationProgressResponse,
  IOrganizationAnalyticsResponse,
} from '@models/organization/response';

import { get, post, put } from './methods';

const BASE_ENDPOINT = 'organizations';

const organizationAPI = {
  find: async () => {
    const response = await get<ApiResponse<IFindOrganizationResponse>>(BASE_ENDPOINT);
    return response.data;
  },
  findOne: async (organizationId: number) => {
    const response = await get<ApiResponse<IFindOneOrganizationResponse>>(`${BASE_ENDPOINT}/${organizationId}`);
    return response.data;
  },
  create: async (body: ICreateOrganizationRequest) => {
    const response = await post<ApiResponse<ICreateOrganizationResponse>>(BASE_ENDPOINT, body);
    return response.data;
  },
  update: async (organizationId: number, body: ICreateOrganizationRequest) => {
    const response = await put<ApiResponse<ICreateOrganizationResponse>>(`${BASE_ENDPOINT}/${organizationId}`, body);
    return response.data;
  },
  getOrganizationAnalytics: async (organizationId: number, params?: IOrganizationAnalyticsRequest) => {
    const response = await get<ApiResponse<IOrganizationAnalyticsResponse>>(
      `${BASE_ENDPOINT}/${organizationId}/analytics`,
      { params },
    );
    return response.data;
  },
  getOrganizationProgress: async (organizationId: number) => {
    const response = await get<ApiResponse<IOrganizationProgressResponse>>(
      `${BASE_ENDPOINT}/${organizationId}/progress`,
    );
    return response.data.data;
  },
};

export default organizationAPI;
